export default __webpack_public_path__ + "static/onepager_podstawa prawna zbierania danych osobowych AML_PLN.pdf";